export default __webpack_public_path__ + "static/media/aunty5.5800acaf.png";